module.exports = __webpack_public_path__ + "static/media/cat-18.2345cd61.jpg";